var render = function render(){var _vm=this,_c=_vm._self._c;return _c('div',{staticClass:"main_content"},[_c('div',{staticClass:"breadcrumbs"}),(!_vm.loading)?_c('div',{staticClass:"help"},[_c('config-bar',{staticClass:"help_bar"}),_c('v-sheet',{staticClass:"help_main",class:{ ['help_full-height']: _vm.routeName === 'help-cam-select' }},[_c('router-view')],1)],1):_vm._e()])
}
var staticRenderFns = []

export { render, staticRenderFns }